import { render, staticRenderFns } from "./EfficiencyForm.vue?vue&type=template&id=2d72a519&scoped=true&"
import script from "./EfficiencyForm.vue?vue&type=script&lang=js&"
export * from "./EfficiencyForm.vue?vue&type=script&lang=js&"
import style0 from "./EfficiencyForm.vue?vue&type=style&index=0&id=2d72a519&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d72a519",
  null
  
)

export default component.exports